import type {HTMLAttributes} from 'react';
import styles from './Controls.module.scss';

export type InputProps = HTMLAttributes<HTMLInputElement> & {
  value?: string | number;
  placeholder?: string;
  type?: string;
  checked?: boolean;
  readOnly?: boolean;
};

export function Input({onChange, onChangeCapture, ...props}: InputProps) {
  return (
    <input
      onChangeCapture={onChangeCapture ?? onChange}
      onChange={onChangeCapture ? (onChange ?? (() => {})) : (() => {})}
      className={styles.input}
      {...props}
    />
  );
}
